import React__default from 'react';
import { COLORS } from '../../../helpers/constants.js';
import styles from './styles.module.scss.js';
import ScaleLoader from '../../../node_modules/react-spinners/esm/ScaleLoader.js';

/**
 * @description Nimvelo Loader component
 * @props style, height, width, margin, radius, color, loading, size, labelText, labelPosition
 */
const NvLoader = ({ style, height, width, margin, radius = '1000px', color = COLORS.PRIMARY, loading = true, size = 'standard', labelText, labelPosition = 'left', }) => {
    let heightValue;
    let widthValue;
    let marginValue;
    const setSize = (h, w, m) => {
        heightValue = height || h;
        widthValue = width || w;
        marginValue = margin || m;
    };
    switch (size) {
        case 'xsmall':
            setSize('5px', '2px', '1px');
            break;
        case 'small':
            setSize('15px', '2px', '2px');
            break;
        case 'standard':
        default:
            setSize('30px', '4px', '2px');
            break;
        case 'large':
            setSize('60px', '6px', '4px');
            break;
        case 'xlarge':
            setSize('100px', '8px', '10px');
            break;
    }
    return (React__default.createElement("div", { className: `${styles.wrapper} ${styles[labelPosition]} ${styles[size]}`, style: { ...style } },
        labelText && React__default.createElement("span", { className: styles.label }, labelText),
        React__default.createElement(ScaleLoader, { loading: loading, color: color, height: heightValue, width: widthValue, margin: marginValue, radius: radius, cssOverride: { display: 'flex' } })));
};

export { NvLoader, NvLoader as default };
//# sourceMappingURL=component.js.map
